/* tslint:disable */
import * as React from "react";

const SvgIconCamera = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 100 75" {...props}>
    <path
      d="M92.06 12.5h-14.2a4.22 4.22 0 0 1-3.12-1.41C67.34 2.81 64.56 0 61.54 0H39.27c-3.05 0-6 2.81-13.46 11.12a4.17 4.17 0 0 1-3.1 1.38h-1.07v-2.08a2.09 2.09 0 0 0-2.08-2.09h-6.77a2.1 2.1 0 0 0-2.09 2.09v2.08H8.75c-4.61 0-8.75 3.44-8.75 8v45.83A9 9 0 0 0 8.72 75h83.34c4.58 0 7.94-4.11 7.94-8.67V20.49a7.76 7.76 0 0 0-7.94-7.99zM51 64.69a22.26 22.26 0 1 1 21.2-21.2A22.28 22.28 0 0 1 51 64.69zM75 27.6a3.39 3.39 0 1 1 3.39-3.38A3.38 3.38 0 0 1 75 27.6z"
      fill="#fff"
      data-name="audio controls"
    />
  </svg>
);

export default SvgIconCamera;

